import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/component/block/pageWrapper/pageWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/component/page/spot/spots-loader/spots-loader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
